import { BASEURL } from "../BaseUrl";

/**
 * Retrieves headers from a part file for data quality analysis.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The parameters for the request, such as file details.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getHeadersFromPartFileApi = async (axios, data) => {
  return await axios.get(`${BASEURL}/data-quality/get-headers-from-part-file`, {
    params: data,
  });
};

/**
 * Fetches the list of validation rules for data quality.
 * @param {Object} axios - The Axios instance to use for the request.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getValidationListApi = async (axios) => {
  return await axios.get(`${BASEURL}/data-quality/get-validation-list`, {});
};

/**
 * Fetches JSON data related to data quality from a specified path.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} path - The path to the JSON data.
 * @param {string} id - The ID of the workflow associated with the JSON data.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const fetchHtmlJsonApi = async (axios, path, id) => {
  return await axios.get(`${BASEURL}/data-quality/read-dq-json`, {
    params: { prefix: path, workflow_id: id },
  });
};

/**
 * Retrieves HTML content related to data quality from a specified path.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} path - The path to the HTML content.
 * @param {string} workflow_id - The ID of the workflow associated with the HTML content.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const fetchHtmlApi = async (axios, path, workflow_id) => {
  return await axios.get(`${BASEURL}/data-quality/get-html`, {
    params: { path, workflow_id },
  });
};

export const DataQualityApi = {
  getHeadersFromPartFileApi,
  getValidationListApi,
  fetchHtmlJsonApi,
  fetchHtmlApi,
};
